export const checkUserRole_actionTypes = {
    CHECK_USER_ROLE: "CHECK_USER_ROLE",
    CHECK_USER_ROLE_SUCCESS: "CHECK_USER_ROLE_SUCCESS",
    CHECK_USER_ROLE_ERROR: "CHECK_USER_ROLE_ERROR"
};